"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.import_binding = void 0;
exports.import_binding = {
    $grammar: {
        "import_binding:name": [{ name: "name" }, { $ap: ["optional", '","'] }],
        "import_binding:alias": [
            { name: "name" },
            '"as"',
            { alias: "name" },
            { $ap: ["optional", '","'] },
        ],
    },
};
//# sourceMappingURL=import_binding.js.map